import { Icon } from 'screens/Calendar/WeekViewV2/CalendarEventCard/Icon'
import Styles from './CalendarItemChannelLabel.module.scss'
import { BrandPlan } from 'types'
import { AlmanacFileCalendarEvent } from 'screens/Calendar/types'
import { DesignChannel } from 'components/NewFileModal/Types'
import { getResolvedLabel } from 'screens/Calendar/WeekViewV2/CalendarEventCard/utils'
import { Text } from 'blaze-ui/Text/Text'
import { AI } from 'blaze-ui/icons'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { ContentTypeIcon, getContentTypeLabel } from 'screens/Calendar/FullScreenPreview/V3/ContentTypeIcon'
import { startCase } from 'lodash'
import { AlmanacFileShowItem, ViewMetadata } from 'hooks/queries/files/types'

type Props = {
  brandPlan?: BrandPlan
  channel?: DesignChannel | ChannelType
  event: AlmanacFileCalendarEvent
  isAIGeneratedVideo: boolean
  isHovered?: boolean
}

export const CalendarItemChannelLabel = (props: Props) => {
  const { isHovered, brandPlan, event, isAIGeneratedVideo, channel } = props
  const { asset_type } = event

  if (brandPlan?.has_content_strategies) {
    const mappedEvent = {
      ...event,
      previous_file_key: '',
      next_file_key: '',
      seo_string: '',
      post_status: '',
      view_metadata: {} as ViewMetadata,
    }

    return (
      <div className={Styles.root}>
        <ContentTypeIcon channel={channel} almanacFile={mappedEvent as AlmanacFileShowItem} />
        <Text variant="label" color="var(--dark-90)" lineClamp={1}>
          {startCase(getContentTypeLabel(channel, mappedEvent as AlmanacFileShowItem))}
        </Text>
      </div>
    )
  }

  return (
    <div className={Styles.root}>
      <Icon event={event} isHovered={!!isHovered} brandPlan={brandPlan} />
      {channel ? (
        <Text variant="label" color="var(--dark-40)" lineClamp={1}>
          {getResolvedLabel({ ...event, channel })}
        </Text>
      ) : (
        <Text variant="label" color="var(--dark-40)" lineClamp={1}>
          {asset_type === 'Article' && 'Doc'}
          {asset_type === 'Design' && 'Post'}
        </Text>
      )}
      {isAIGeneratedVideo && <AI size={15} color="#a229fe" />}
    </div>
  )
}
